msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/components/EditEditor.tsx
msgid " · Saving…"
msgstr " · Saving…"

#: src/components/ToolCardMessage.tsx
msgid " (new)"
msgstr " (new)"

#: src/components/ToolCardMessage.tsx
msgid "… (truncated)"
msgstr "… (truncated)"

#: src/components/MessageItem.tsx
msgid "(edited)"
msgstr "(edited)"

#. placeholder {0}: history.length
#: src/components/EditHistoryModal.tsx
msgid "{0, plural, one {# edit} other {# edits}}"
msgstr "{0, plural, one {# edit} other {# edits}}"

#. placeholder {0}: lines.length
#: src/components/ToolCardMessage.tsx
msgid "{0, plural, one {# line} other {# lines}}"
msgstr "{0, plural, one {# line} other {# lines}}"

#. placeholder {0}: thread.message_count
#: src/components/MessageItem.tsx
msgid "{0, plural, one {# reply} other {# replies}}"
msgstr "{0, plural, one {# reply} other {# replies}}"

#. placeholder {0}: result.total
#: src/components/ToolCardMessage.tsx
msgid "{0, plural, one {# result} other {# results}}"
msgstr "{0, plural, one {# result} other {# results}}"

#. placeholder {0}: replies.length
#: src/components/DMThread.tsx
msgid "{0, plural, one {Hide # reply} other {Hide # replies}}"
msgstr "{0, plural, one {Hide # reply} other {Hide # replies}}"

#. placeholder {0}: replies.length
#: src/components/DMThread.tsx
msgid "{0, plural, one {Show # reply} other {Show # replies}}"
msgstr "{0, plural, one {Show # reply} other {Show # replies}}"

#. placeholder {0}: lines.length
#. placeholder {1}: result.totalLines
#: src/components/ToolCardMessage.tsx
msgid "{0}/{1} lines"
msgstr "{0}/{1} lines"

#: src/components/DshSessionChatView.tsx
msgid "{agentName} session"
msgstr "{agentName} session"

#: src/components/DirectMessageEmptyState.tsx
msgid "{displayName} is ready for context, questions, and task collaboration."
msgstr "{displayName} is ready for context, questions, and task collaboration."

#: src/components/FilesPanel.tsx
msgid "A file with that name already exists"
msgstr "A file with that name already exists"

#: src/components/MessageInput.tsx
msgid "A message can contain at most 10 attachments"
msgstr "A message can contain at most 10 attachments"

#: src/components/SystemMessageBubble.tsx
msgid "Add agent"
msgstr "Add agent"

#: src/components/EmojiPickerPopover.tsx
#: src/components/ReactionAddButton.tsx
msgid "Add reaction"
msgstr "Add reaction"

#: src/components/DirectMessagePanel.tsx
msgid "Agent"
msgstr "Agent"

#. placeholder {0}: i18n._(agentStates[state ?? 'ready'] ?? msg`Unknown`)
#: src/components/DirectMessageEmptyState.tsx
msgid "Agent · {0}"
msgstr "Agent · {0}"

#: src/components/AttachmentGrid.tsx
msgid "Attachment"
msgstr "Attachment"

#: src/components/MessageInput.tsx
msgid "Attachments can total at most 50 MB"
msgstr "Attachments can total at most 50 MB"

#: src/components/MessageInput.tsx
msgid "Attachments cannot be sent to this native session. Send them from Messages or remove them first."
msgstr "Attachments cannot be sent to this native session. Send them from Messages or remove them first."

#: src/components/SystemMessageBubble.tsx
msgid "Authorize"
msgstr "Authorize"

#: src/components/DshSessionChatView.tsx
msgid "Awaiting session"
msgstr "Awaiting session"

#: src/components/SlashCommandPicker.tsx
msgid "Back"
msgstr "Back"

#: src/components/Toolbar.tsx
msgid "Blockquote"
msgstr "Blockquote"

#: src/components/Toolbar.tsx
msgid "Bold (Ctrl+B)"
msgstr "Bold (Ctrl+B)"

#: src/components/Toolbar.tsx
msgid "Bullet list (Ctrl+Shift+8)"
msgstr "Bullet list (Ctrl+Shift+8)"

#: src/components/DirectMessageEmptyState.tsx
msgid "Busy"
msgstr "Busy"

#: src/components/CommandParamForm.tsx
#: src/components/MarkdownEditor.tsx
#: src/components/MessageItem.tsx
msgid "Cancel"
msgstr "Cancel"

#: src/commands/builtins.ts
msgid "Change your display name"
msgstr "Change your display name"

#: src/components/MessageList.tsx
msgid "channel"
msgstr "channel"

#: src/commands/builtins.ts
msgid "Channel member roster is unavailable. Join the channel to use /status."
msgstr "Channel member roster is unavailable. Join the channel to use /status."

#: src/components/SlashCommandPicker.tsx
msgid "Choose agent"
msgstr "Choose agent"

#: src/components/FilesPanel.tsx
msgid "Clear"
msgstr "Clear"

#: src/commands/builtins.ts
msgid "Clear local chat history"
msgstr "Clear local chat history"

#: src/commands/builtins.ts
msgid "Clear local chat history? This only clears the local display and does not affect server data."
msgstr "Clear local chat history? This only clears the local display and does not affect server data."

#: src/components/EditHistoryModal.tsx
#: src/components/MarkdownEditor.tsx
#: src/components/SlashCommandPicker.tsx
msgid "Close"
msgstr "Close"

#: src/components/DirectMessagePanel.tsx
msgid "Close direct message"
msgstr "Close direct message"

#: src/components/FileViewer.tsx
#: src/components/RemoteFileViewer.tsx
msgid "Close file preview"
msgstr "Close file preview"

#: src/components/ThreadPanelHeader.tsx
msgid "Close thread"
msgstr "Close thread"

#: src/components/DshSessionChatView.tsx
msgid "Closed"
msgstr "Closed"

#: src/components/Toolbar.tsx
msgid "Code block"
msgstr "Code block"

#: src/components/MessageInput.tsx
msgid "Command failed"
msgstr "Command failed"

#: src/components/CommandResultCard.tsx
msgid "Completed"
msgstr "Completed"

#: src/components/DshSessionChatView.tsx
msgid "Connecting"
msgstr "Connecting"

#: src/components/DshSessionChatView.tsx
msgid "Connection interrupted. Check each message’s send status before retrying."
msgstr "Connection interrupted. Check each message’s send status before retrying."

#: src/lib/interaction-responses.ts
msgid "Connection is disconnected."
msgstr "Connection is disconnected."

#: src/lib/interaction-responses.ts
msgid "Connection is disconnected. The answer may have been accepted."
msgstr "Connection is disconnected. The answer may have been accepted."

#: src/hooks/useDMEdit.ts
msgid "Could not edit message: the conversation or message is missing."
msgstr "Could not edit message: the conversation or message is missing."

#: src/components/EditEditor.tsx
msgid "Ctrl+Enter to save · Esc to cancel"
msgstr "Ctrl+Enter to save · Esc to cancel"

#: src/components/MarkdownEditor.tsx
msgid "Ctrl+S to save · Esc to cancel"
msgstr "Ctrl+S to save · Esc to cancel"

#: src/components/FilesPanel.tsx
#: src/components/MessageItem.tsx
msgid "Delete"
msgstr "Delete"

#. placeholder {0}: file.name
#: src/components/FilesPanel.tsx
msgid "Delete {0}?"
msgstr "Delete {0}?"

#: src/components/MessageItem.tsx
msgid "Delete this message?"
msgstr "Delete this message?"

#: src/components/DirectMessageEmptyState.tsx
#: src/components/DirectMessagePanel.tsx
msgid "Direct message"
msgstr "Direct message"

#: src/components/MentionList.tsx
msgid "Direct messages are for two people. Create a channel to include others."
msgstr "Direct messages are for two people. Create a channel to include others."

#: src/components/DshSessionChatView.tsx
msgid "Disconnected"
msgstr "Disconnected"

#: src/commands/builtins.ts
msgid "Display name changed:"
msgstr "Display name changed:"

#: src/components/ThreadPanelHeader.tsx
msgid "Dock the thread beside the channel"
msgstr "Dock the thread beside the channel"

#: src/components/AttachmentGrid.tsx
#: src/components/FileViewer.tsx
msgid "Download"
msgstr "Download"

#. placeholder {0}: file.filename
#: src/components/AttachmentGrid.tsx
msgid "Download {0}"
msgstr "Download {0}"

#: src/components/FileViewer.tsx
msgid "Download file"
msgstr "Download file"

#: src/components/FileViewer.tsx
msgid "Downloading…"
msgstr "Downloading…"

#: src/components/FilesPanel.tsx
msgid "Drop files here to upload"
msgstr "Drop files here to upload"

#: src/components/MessageInput.tsx
msgid "Each attachment must be 10 MB or smaller"
msgstr "Each attachment must be 10 MB or smaller"

#: src/components/MessageItem.tsx
#: src/components/viewers/MarkdownViewer.tsx
msgid "Edit"
msgstr "Edit"

#: src/components/MarkdownEditor.tsx
msgid "Edit {fileName}"
msgstr "Edit {fileName}"

#: src/components/EditHistoryModal.tsx
msgid "Edit history"
msgstr "Edit history"

#. placeholder {0}: formatTime(message.edited_at, i18n)
#: src/components/MessageItem.tsx
msgid "Edited at {0}"
msgstr "Edited at {0}"

#: src/components/RemoteTree.tsx
msgid "Empty directory"
msgstr "Empty directory"

#: src/commands/builtins.ts
msgid "Enter the channel topic…"
msgstr "Enter the channel topic…"

#: src/components/DirectMessageEmptyState.tsx
msgid "Error"
msgstr "Error"

#: src/components/CommandParamForm.tsx
msgid "Execute"
msgstr "Execute"

#: src/components/CommandResultCard.tsx
msgid "Executing…"
msgstr "Executing…"

#. placeholder {0}: typeof result.exitCode === 'number' ? result.exitCode : '?'
#: src/components/ToolCardMessage.tsx
msgid "Exit code: {0}"
msgstr "Exit code: {0}"

#: src/components/ThreadPanelHeader.tsx
msgid "Expand session to workspace"
msgstr "Expand session to workspace"

#: src/components/CommandResultCard.tsx
#: src/components/DshSessionChatView.tsx
msgid "Failed"
msgstr "Failed"

#: src/components/ReactionAddButton.tsx
msgid "Failed to add reaction. Please try again."
msgstr "Failed to add reaction. Please try again."

#: src/components/FileViewer.tsx
msgid "Failed to download file"
msgstr "Failed to download file"

#: src/hooks/useDMEdit.ts
msgid "Failed to edit message"
msgstr "Failed to edit message"

#: src/components/RemoteTree.tsx
msgid "Failed to load directory"
msgstr "Failed to load directory"

#: src/components/EditHistoryModal.tsx
msgid "Failed to load edit history"
msgstr "Failed to load edit history"

#: src/components/FileViewer.tsx
msgid "Failed to load file"
msgstr "Failed to load file"

#: src/components/viewers/PdfViewer.tsx
msgid "Failed to load PDF preview"
msgstr "Failed to load PDF preview"

#: src/components/FileLink.tsx
#: src/components/RemoteTree.tsx
msgid "Failed to read file"
msgstr "Failed to read file"

#: src/components/viewers/PdfViewer.tsx
msgid "Failed to render this PDF page"
msgstr "Failed to render this PDF page"

#: src/components/FilesPanel.tsx
msgid "File"
msgstr "File"

#: src/components/FileLink.tsx
#: src/components/RemoteTree.tsx
msgid "File is too large to preview"
msgstr "File is too large to preview"

#: src/components/FileLink.tsx
msgid "File not found"
msgstr "File not found"

#: src/components/FileLink.tsx
msgid "File read timed out"
msgstr "File read timed out"

#: src/components/FilesPanel.tsx
msgid "File search failed"
msgstr "File search failed"

#: src/components/FilesPanel.tsx
msgid "Files"
msgstr "Files"

#: src/components/FilesPanel.tsx
msgid "Folder"
msgstr "Folder"

#: src/components/FilesPanel.tsx
msgid "Folder name:"
msgstr "Folder name:"

#: src/components/AttachmentGrid.tsx
msgid "Full size image"
msgstr "Full size image"

#: src/components/ThreadPanelHeader.tsx
msgid "Go to channel"
msgstr "Go to channel"

#: src/components/HeartbeatCollapsed.tsx
msgid "Heartbeat × {count}"
msgstr "Heartbeat × {count}"

#: src/components/HeartbeatCollapsed.tsx
#: src/components/MessageItem.tsx
msgid "Heartbeat: status update requested"
msgstr "Heartbeat: status update requested"

#: src/components/DirectMessageEmptyState.tsx
msgid "Help me with a task"
msgstr "Help me with a task"

#: src/components/DshSessionChatView.tsx
msgid "Hide receipt"
msgstr "Hide receipt"

#: src/components/DshSessionChatView.tsx
msgid "Hide this receipt in this browser. The message stays in Messages."
msgstr "Hide this receipt in this browser. The message stays in Messages."

#: src/components/DirectMessageEmptyState.tsx
#: src/components/DshSessionChatView.tsx
msgid "Idle"
msgstr "Idle"

#: src/components/MessageItem.tsx
msgid "Image failed to load"
msgstr "Image failed to load"

#: src/components/FilesPanel.tsx
msgid "Image file"
msgstr "Image file"

#: src/components/MessageItem.tsx
msgid "Image links must use http(s):// or a same-origin path"
msgstr "Image links must use http(s):// or a same-origin path"

#: src/components/Toolbar.tsx
msgid "Inline code (Ctrl+E)"
msgstr "Inline code (Ctrl+E)"

#: src/commands/builtins.ts
msgid "Invite a user to the channel"
msgstr "Invite a user to the channel"

#: src/components/Toolbar.tsx
msgid "Italic (Ctrl+I)"
msgstr "Italic (Ctrl+I)"

#. placeholder {0}: parentChannel.name
#: src/components/ThreadPanel.tsx
msgid "Join #{0} to reply"
msgstr "Join #{0} to reply"

#: src/components/ThreadPanel.tsx
msgid "Join the channel to reply"
msgstr "Join the channel to reply"

#: src/components/ThreadPanel.tsx
msgid "Joining…"
msgstr "Joining…"

#: src/components/DshSessionChatView.tsx
msgid "Jump to latest ↓"
msgstr "Jump to latest ↓"

#: src/components/SystemMessageBubble.tsx
msgid "Later"
msgstr "Later"

#: src/commands/builtins.ts
msgid "Leave the current channel"
msgstr "Leave the current channel"

#: src/commands/builtins.ts
msgid "Leave the current channel?"
msgstr "Leave the current channel?"

#: src/components/MessageList.tsx
msgid "Load earlier messages"
msgstr "Load earlier messages"

#: src/components/DirectMessagePanel.tsx
msgid "Loading conversation…"
msgstr "Loading conversation…"

#: src/components/viewers/PdfViewer.tsx
msgid "Loading PDF…"
msgstr "Loading PDF…"

#: src/components/DshSessionChatView.tsx
msgid "Loading saved activity…"
msgstr "Loading saved activity…"

#: src/components/DshSessionChatView.tsx
#: src/components/FilesPanel.tsx
#: src/components/FileViewer.tsx
#: src/components/MessageList.tsx
#: src/components/RemoteTree.tsx
msgid "Loading…"
msgstr "Loading…"

#: src/commands/builtins.ts
msgid "Local chat history cleared"
msgstr "Local chat history cleared"

#: src/components/DshSessionChatView.tsx
msgid "Local history"
msgstr "Local history"

#: src/commands/builtins.ts
msgid "Members: {memberCount} ({onlineCount} online)"
msgstr "Members: {memberCount} ({onlineCount} online)"

#: src/components/DirectMessageEmptyState.tsx
msgid "Message {displayName}"
msgstr "Message {displayName}"

#: src/components/MessageItem.tsx
msgid "Message actions"
msgstr "Message actions"

#: src/hooks/useDMEdit.ts
msgid "Message content cannot be empty."
msgstr "Message content cannot be empty."

#: src/components/SlashCommandPicker.tsx
msgid "Multiple agents provide this command:"
msgstr "Multiple agents provide this command:"

#: src/commands/builtins.ts
msgid "New display name…"
msgstr "New display name…"

#: src/components/FilesPanel.tsx
msgid "New folder"
msgstr "New folder"

#: src/components/MessageList.tsx
msgid "New messages"
msgstr "New messages"

#: src/components/DshSessionChatView.tsx
msgid "New task activity is unavailable because earlier requests occupy the local display capacity."
msgstr "New task activity is unavailable because earlier requests occupy the local display capacity."

#: src/components/ThreadPanel.tsx
msgid "New thread"
msgstr "New thread"

#: src/components/FilesPanel.tsx
#: src/components/viewers/PdfViewer.tsx
msgid "Next page"
msgstr "Next page"

#: src/components/SlashCommandPicker.tsx
msgid "No commands found"
msgstr "No commands found"

#: src/components/FilesPanel.tsx
msgid "No files yet"
msgstr "No files yet"

#: src/components/FilesPanel.tsx
msgid "No matching files"
msgstr "No matching files"

#: src/components/DshSessionChatView.tsx
msgid "No session activity yet"
msgstr "No session activity yet"

#: src/commands/builtins.ts
msgid "None"
msgstr "None"

#: src/components/Toolbar.tsx
msgid "Numbered list (Ctrl+Shift+9)"
msgstr "Numbered list (Ctrl+Shift+9)"

#: src/components/DirectMessageEmptyState.tsx
msgid "Offline"
msgstr "Offline"

#: src/commands/builtins.ts
msgid "Offline:"
msgstr "Offline:"

#: src/components/DshSessionChatView.tsx
msgid "Older activity was removed to make room in this browser."
msgstr "Older activity was removed to make room in this browser."

#: src/components/DirectMessageEmptyState.tsx
msgid "Online"
msgstr "Online"

#: src/commands/builtins.ts
msgid "Online:"
msgstr "Online:"

#: src/components/DshSessionChatView.tsx
#: src/lib/interaction-responses.ts
msgid "Only the agent owner can respond."
msgstr "Only the agent owner can respond."

#: src/components/FileViewer.tsx
msgid "Only the first 1 MB is shown. Download the file to view all content."
msgstr "Only the first 1 MB is shown. Download the file to view all content."

#: src/components/FilesPanel.tsx
msgid "Open"
msgstr "Open"

#: src/commands/builtins.ts
msgid "Open a direct message with a user"
msgstr "Open a direct message with a user"

#. placeholder {0}: img.filename
#: src/components/AttachmentGrid.tsx
msgid "Open image {0}"
msgstr "Open image {0}"

#: src/components/AttachmentGrid.tsx
msgid "Open image attachment"
msgstr "Open image attachment"

#: src/components/DshSessionChatView.tsx
msgid "Open in Messages"
msgstr "Open in Messages"

#: src/components/DshSessionChatView.tsx
msgid "Open Messages to retry"
msgstr "Open Messages to retry"

#: src/components/DirectMessageEmptyState.tsx
msgid "Or write a message below."
msgstr "Or write a message below."

#. placeholder {0}: document.numPages
#: src/components/viewers/PdfViewer.tsx
msgid "Page {pageNumber} of {0}"
msgstr "Page {pageNumber} of {0}"

#: src/components/RemoteTree.tsx
msgid "Parent folder"
msgstr "Parent folder"

#: src/components/viewers/PdfViewer.tsx
msgid "PDF page {pageNumber}"
msgstr "PDF page {pageNumber}"

#: src/components/viewers/PdfViewer.tsx
msgid "PDF preview controls"
msgstr "PDF preview controls"

#: src/components/viewers/DocxViewer.tsx
msgid "Preparing document preview…"
msgstr "Preparing document preview…"

#: src/components/FileViewer.tsx
#: src/components/RemoteFileViewer.tsx
msgid "Preview is not supported for this file type"
msgstr "Preview is not supported for this file type"

#: src/components/FilesPanel.tsx
#: src/components/viewers/PdfViewer.tsx
msgid "Previous page"
msgstr "Previous page"

#: src/components/ReactionAddButton.tsx
msgid "React"
msgstr "React"

#: src/components/ThreadPanel.tsx
msgid "Read-only"
msgstr "Read-only"

#: src/components/DshSessionChatView.tsx
msgid "Read-only · This saved request is not currently confirmed as active."
msgstr "Read-only · This saved request is not currently confirmed as active."

#: src/components/DirectMessageEmptyState.tsx
msgid "Ready"
msgstr "Ready"

#: src/components/SystemMessageBubble.tsx
msgid "Reconnect"
msgstr "Reconnect"

#: src/components/DshSessionChatView.tsx
msgid "Reconnecting"
msgstr "Reconnecting"

#: src/components/DshSessionChatView.tsx
msgid "Recovery failed"
msgstr "Recovery failed"

#: src/components/SystemMessageBubble.tsx
msgid "Reject"
msgstr "Reject"

#: src/components/DshSessionChatView.tsx
msgid "Remote Control is paused in this browser because complete session state could not be saved. The view is stale. The agent may still be running."
msgstr "Remote Control is paused in this browser because complete session state could not be saved. The view is stale. The agent may still be running."

#: src/components/DshSessionChatView.tsx
msgid "Remote Control is waiting for a complete session synchronization. Saved history is stale and controls are unavailable."
msgstr "Remote Control is waiting for a complete session synchronization. Saved history is stale and controls are unavailable."

#: src/components/RemoteTree.tsx
msgid "Remote node is offline"
msgstr "Remote node is offline"

#. placeholder {0}: file.name
#: src/components/MessageInput.tsx
msgid "Remove {0}"
msgstr "Remove {0}"

#: src/components/MessageInput.tsx
msgid "Remove attachment"
msgstr "Remove attachment"

#: src/components/MessageInput.tsx
msgid "Remove these attachments before sending, or send them from Messages."
msgstr "Remove these attachments before sending, or send them from Messages."

#: src/components/FilesPanel.tsx
msgid "Rename"
msgstr "Rename"

#: src/components/FilesPanel.tsx
msgid "Rename failed"
msgstr "Rename failed"

#: src/components/FilesPanel.tsx
msgid "Rename to:"
msgstr "Rename to:"

#: src/components/viewers/PdfViewer.tsx
msgid "Rendering page…"
msgstr "Rendering page…"

#: src/components/DMThread.tsx
msgid "Reply…"
msgstr "Reply…"

#: src/components/viewers/ImageViewer.tsx
msgid "Reset zoom"
msgstr "Reset zoom"

#: src/lib/interaction-responses.ts
msgid "Response confirmation timed out. The answer may have been accepted."
msgstr "Response confirmation timed out. The answer may have been accepted."

#: src/lib/interaction-responses.ts
msgid "Response could not be sent. The answer may have been accepted."
msgstr "Response could not be sent. The answer may have been accepted."

#: src/components/ThreadPanelHeader.tsx
msgid "Restore session width"
msgstr "Restore session width"

#: src/components/DshSessionChatView.tsx
msgid "Resynchronize session"
msgstr "Resynchronize session"

#: src/components/MessageItem.tsx
msgid "Retry"
msgstr "Retry"

#: src/components/DshSessionChatView.tsx
msgid "Retry history"
msgstr "Retry history"

#: src/components/FilesPanel.tsx
msgid "Root"
msgstr "Root"

#: src/components/MarkdownEditor.tsx
msgid "Save"
msgstr "Save"

#: src/components/FilesPanel.tsx
msgid "Search"
msgstr "Search"

#: src/components/FilesPanel.tsx
msgid "Search files"
msgstr "Search files"

#: src/components/FilesPanel.tsx
msgid "Searching…"
msgstr "Searching…"

#: src/commands/builtins.ts
msgid "Select a user…"
msgstr "Select a user…"

#: src/components/DMThread.tsx
msgid "Send"
msgstr "Send"

#: src/components/DshSessionChatView.tsx
msgid "Send a message to {agentName}. Messages, reasoning, and tools will appear here as they arrive."
msgstr "Send a message to {agentName}. Messages, reasoning, and tools will appear here as they arrive."

#: src/components/MessageInput.tsx
#: src/components/MessageItem.tsx
msgid "Send failed"
msgstr "Send failed"

#: src/components/MessageInput.tsx
msgid "Send message"
msgstr "Send message"

#: src/components/DshSessionChatView.tsx
msgid "Send not confirmed"
msgstr "Send not confirmed"

#: src/components/DshSessionChatView.tsx
#: src/components/MessageInput.tsx
#: src/components/MessageItem.tsx
msgid "Sending…"
msgstr "Sending…"

#: src/components/MessageItem.tsx
msgid "Sent"
msgstr "Sent"

#: src/components/DshSessionChatView.tsx
msgid "Sent to conversation"
msgstr "Sent to conversation"

#: src/components/DshSessionChatView.tsx
msgid "Session unavailable"
msgstr "Session unavailable"

#: src/components/DshSessionChatView.tsx
msgid "Session updates stopped. Restore the agent connection to continue. Saved history may be stale."
msgstr "Session updates stopped. Restore the agent connection to continue. Saved history may be stale."

#: src/commands/builtins.ts
msgid "Set the channel topic"
msgstr "Set the channel topic"

#: src/commands/builtins.ts
msgid "Show all available commands"
msgstr "Show all available commands"

#: src/commands/builtins.ts
msgid "Show channel status"
msgstr "Show channel status"

#: src/components/DirectMessageEmptyState.tsx
msgid "Show your current context"
msgstr "Show your current context"

#: src/components/SlashCommandPicker.tsx
msgid "Slash commands"
msgstr "Slash commands"

#: src/components/viewers/DocxViewer.tsx
msgid "Some document content could not be displayed."
msgstr "Some document content could not be displayed."

#: src/components/DshSessionChatView.tsx
msgid "Stale"
msgstr "Stale"

#: src/components/DirectMessageEmptyState.tsx
msgid "Start a conversation with {displayName}"
msgstr "Start a conversation with {displayName}"

#: src/components/DshSessionChatView.tsx
msgid "Synchronization failed. Restore available storage or the session connection, then retry."
msgstr "Synchronization failed. Restore available storage or the session connection, then retry."

#: src/components/DshSessionChatView.tsx
msgid "Synchronizing…"
msgstr "Synchronizing…"

#: src/commands/builtins.ts
#: src/components/MessageItem.tsx
#: src/components/SlashCommandPicker.tsx
msgid "System"
msgstr "System"

#: src/components/FilesPanel.tsx
msgid "Text file"
msgstr "Text file"

#: src/lib/interaction-responses.ts
msgid "The agent could not accept this response. The request may already be resolved."
msgstr "The agent could not accept this response. The request may already be resolved."

#: src/lib/interaction-responses.ts
msgid "The agent is disconnected."
msgstr "The agent is disconnected."

#: src/components/FileLink.tsx
msgid "The agent is offline. Unable to read the file."
msgstr "The agent is offline. Unable to read the file."

#: src/components/CommandResultCard.tsx
msgid "The agent may be offline"
msgstr "The agent may be offline"

#: src/lib/interaction-responses.ts
msgid "The agent returned an invalid interaction result."
msgstr "The agent returned an invalid interaction result."

#: src/lib/interaction-responses.ts
msgid "The Agent returned an invalid interaction result."
msgstr "The Agent returned an invalid interaction result."

#. placeholder {0}: filename ?? ''
#: src/components/MessageInput.tsx
msgid "The attachment filename is not allowed: {0}"
msgstr "The attachment filename is not allowed: {0}"

#. placeholder {0}: filename ?? ''
#: src/components/MessageInput.tsx
msgid "The attachment type does not match its extension: {0}"
msgstr "The attachment type does not match its extension: {0}"

#: src/components/DshSessionChatView.tsx
msgid "The connection is unavailable. This request is read-only."
msgstr "The connection is unavailable. This request is read-only."

#: src/lib/interaction-responses.ts
msgid "The control result is unconfirmed. Check the session state before trying again. Your draft is preserved."
msgstr "The control result is unconfirmed. Check the session state before trying again. Your draft is preserved."

#: src/lib/interaction-responses.ts
msgid "The interaction response is invalid or too large. Shorten the answer and try again."
msgstr "The interaction response is invalid or too large. Shorten the answer and try again."

#: src/lib/interaction-responses.ts
msgid "The interaction response is invalid."
msgstr "The interaction response is invalid."

#: src/lib/interaction-responses.ts
msgid "The interaction response is too large for this connection. It was not sent; the original request is unchanged."
msgstr "The interaction response is too large for this connection. It was not sent; the original request is unchanged."

#: src/components/DshSessionChatView.tsx
msgid "The latest history could not be loaded. Live activity continues."
msgstr "The latest history could not be loaded. Live activity continues."

#. placeholder {0}: filename ?? ''
#: src/components/MessageInput.tsx
msgid "This attachment type is not supported: {0}"
msgstr "This attachment type is not supported: {0}"

#: src/components/DshSessionChatView.tsx
msgid "This conversation is read-only."
msgstr "This conversation is read-only."

#: src/components/FileViewer.tsx
#: src/components/viewers/DocxViewer.tsx
msgid "This DOCX file is damaged or cannot be previewed"
msgstr "This DOCX file is damaged or cannot be previewed"

#: src/components/FileViewer.tsx
msgid "This file is not valid UTF-8 text"
msgstr "This file is not valid UTF-8 text"

#: src/components/FileViewer.tsx
msgid "This file is too large to preview safely"
msgstr "This file is too large to preview safely"

#: src/lib/interaction-responses.ts
msgid "This interaction is no longer available."
msgstr "This interaction is no longer available."

#: src/components/DshSessionChatView.tsx
msgid "This interaction is unavailable for the current session."
msgstr "This interaction is unavailable for the current session."

#: src/components/viewers/DocxViewer.tsx
msgid "This is a simplified read-only preview. Layout may differ from Microsoft Word."
msgstr "This is a simplified read-only preview. Layout may differ from Microsoft Word."

#: src/components/MessageList.tsx
msgid "This is the beginning of the #{channelName} channel."
msgstr "This is the beginning of the #{channelName} channel."

#: src/components/MessageList.tsx
msgid "This is the beginning of the conversation"
msgstr "This is the beginning of the conversation"

#: src/components/DirectMessageEmptyState.tsx
msgid "This is the beginning of your private conversation with {displayName}."
msgstr "This is the beginning of your private conversation with {displayName}."

#: src/components/MessageItem.tsx
msgid "This message was deleted"
msgstr "This message was deleted"

#: src/components/DshSessionChatView.tsx
msgid "This native session cannot provide its complete pending requests. Resume it through Borgee before retrying Remote Control."
msgstr "This native session cannot provide its complete pending requests. Resume it through Borgee before retrying Remote Control."

#: src/components/FileLink.tsx
msgid "This path is outside the allowed read scope"
msgstr "This path is outside the allowed read scope"

#: src/components/FileViewer.tsx
#: src/components/viewers/PdfViewer.tsx
msgid "This PDF is damaged or is not a valid PDF"
msgstr "This PDF is damaged or is not a valid PDF"

#: src/components/viewers/PdfViewer.tsx
msgid "This PDF is password protected and cannot be previewed"
msgstr "This PDF is password protected and cannot be previewed"

#: src/components/DshSessionChatView.tsx
msgid "This session is not available yet."
msgstr "This session is not available yet."

#: src/components/DshSessionChatView.tsx
msgid "This view keeps activity received in this browser. Earlier activity is not downloaded."
msgstr "This view keeps activity received in this browser. Earlier activity is not downloaded."

#: src/components/MessageItem.tsx
#: src/components/ThreadPanel.tsx
msgid "Thread"
msgstr "Thread"

#: src/components/CommandResultCard.tsx
msgid "Timed out"
msgstr "Timed out"

#. placeholder {0}: recipientAgent.name
#: src/components/MessageInput.tsx
msgid "To @{0}"
msgstr "To @{0}"

#: src/lib/interaction-responses.ts
msgid "Too many interaction responses are pending."
msgstr "Too many interaction responses are pending."

#: src/commands/builtins.ts
msgid "Topic:"
msgstr "Topic:"

#: src/components/MentionPicker.tsx
msgid "Type @ to mention channel members…"
msgstr "Type @ to mention channel members…"

#: src/components/DirectMessageEmptyState.tsx
#: src/components/MessageItem.tsx
#: src/components/ThreadPanel.tsx
msgid "Unknown"
msgstr "Unknown"

#: src/components/MessageInput.tsx
msgid "Unknown type"
msgstr "Unknown type"

#: src/components/DshSessionChatView.tsx
msgid "Updates stopped"
msgstr "Updates stopped"

#: src/components/FilesPanel.tsx
msgid "Upload"
msgstr "Upload"

#: src/components/MessageInput.tsx
msgid "Upload files"
msgstr "Upload files"

#: src/components/FilesPanel.tsx
msgid "Upload or drag files here"
msgstr "Upload or drag files here"

#: src/components/MessageItem.tsx
msgid "Uploaded image"
msgstr "Uploaded image"

#: src/commands/builtins.ts
msgid "Usage: {usage}"
msgstr "Usage: {usage}"

#: src/components/DshSessionChatView.tsx
msgid "Waiting for you"
msgstr "Waiting for you"

#: src/components/DirectMessageEmptyState.tsx
msgid "What are you working on?"
msgstr "What are you working on?"

#: src/components/DshSessionChatView.tsx
msgid "Working"
msgstr "Working"

#: src/components/MessageInput.tsx
msgid "Write a message… (Enter to send, Ctrl+Enter for a new line)"
msgstr "Write a message… (Enter to send, Ctrl+Enter for a new line)"

#: src/components/MessageItem.tsx
msgid "Yesterday {timeStr}"
msgstr "Yesterday {timeStr}"

#: src/components/DshSessionChatView.tsx
msgid "You"
msgstr "You"

#: src/components/viewers/PdfViewer.tsx
msgid "Zoom in"
msgstr "Zoom in"

#: src/components/viewers/PdfViewer.tsx
msgid "Zoom out"
msgstr "Zoom out"
